import React, { useState, useEffect } from "react";
import { billingAPI } from "./api/userAPI";
import Dashboard from "./pages/Dashboard";
import UserDashboard from "./components/UserDashboard";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import { ActiveModelProvider } from "./context/ActiveModelContext";
import { DemoProvider } from "./context/DemoContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthWrapper from "./components/AuthWrapper";
import "./components/auth.css";
import "./components/admin.css";

function AppContent() {
  const { isAuthenticated, user, refreshUser } = useAuth();
  const [showUserDashboard, setShowUserDashboard] = useState(false);
  const [showAdminLogin, setShowAdminLogin] = useState(false);
  const [showAdminDashboard, setShowAdminDashboard] = useState(false);

  useEffect(() => {
    const checkStripeReturn = async () => {
      // Check if URL has ?session_id=...
      const urlParams = new URLSearchParams(window.location.search);
      const sessionId = urlParams.get('session_id');

      if (sessionId) {
        console.log("Stripe return detected. Syncing...");
        try {
          // Tell backend to sync (updates DB)
          const result = await billingAPI.syncSession(sessionId);
          
          if (result.success) {
            // Update the frontend user state immediately
            await refreshUser();
            // Clear URL parameters            
            window.history.replaceState({}, document.title, window.location.pathname);
          }
        } catch (error) {
          console.error("Sync failed:", error);
        }
      }
    };

    checkStripeReturn();
  }, [refreshUser]);
  // Check if current user is admin and should see admin dashboard
  const isAdmin = user && (user.role === 'admin' || user.role === 'super_admin');
  
  console.log('AppContent - isAuthenticated:', isAuthenticated, 'user:', user, 'isAdmin:', isAdmin);

  // Show admin dashboard if user is admin or if explicitly requested
  if (showAdminDashboard || isAdmin) {
    console.log('Showing admin dashboard for user:', user?.email, 'role:', user?.role);
    return <AdminDashboard onBack={() => {
      setShowAdminDashboard(false);
      // For admin users, going back means logging out
      if (isAdmin) {
        // Clear the user session and reload
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_data');
        window.location.reload();
      }
    }} />;
  }

  if (showAdminLogin) {
    return (
      <AdminLogin 
        onSuccess={(userData) => {
          console.log('Admin login success, userData:', userData);
          setShowAdminDashboard(true);
        }}
        onCancel={() => setShowAdminLogin(false)}
      />
    );
  }

  if (showUserDashboard) {
    return <UserDashboard onBack={() => setShowUserDashboard(false)} />;
  }

  return (
    <Dashboard 
      onUserDashboardClick={() => setShowUserDashboard(true)}
      onAdminLoginClick={() => setShowAdminLogin(true)}
    />
  );
}

function App() {
  return (
    <AuthProvider>
      <ActiveModelProvider>
        <DemoProvider>
          <AuthWrapper>
            <AppContent />
          </AuthWrapper>
        </DemoProvider>
      </ActiveModelProvider>
    </AuthProvider>
  );
}

export default App;
